import { html, nothing } from "lit";

import { isDraftThread } from "@/lib/draft-thread";
import type { ThreadSchema } from "@/stores/threads-store";

export const draftBadgeTemplate = (
    threads: ThreadSchema[],
    openDrafts: () => void
) => {
    const drafts = threads.filter(
        (thread) => thread.status === "open" && isDraftThread(thread)
    );
    if (!drafts.length) return nothing;

    const count = drafts.length;
    const label = count === 1 ? "1 draft change" : `${count} draft changes`;
    return html`<button
        type="button"
        class="thread-badge"
        title=${label}
        aria-label=${label}
        @click=${(event: MouseEvent) => {
            event.preventDefault();
            event.stopPropagation();
            openDrafts();
        }}
    >
        <span class="thread-badge-icon"></span>
        <span class="thread-badge-count">${count}</span>
    </button>`;
};
